export default __webpack_public_path__ + "static/media/cups.0f155538.png";